// extracted by mini-css-extract-plugin
export default {"element":"CarouselArrow-module--element--b7d67","left":"CarouselArrow-module--left--536fe"};